export default {
  familyName: 'Helvetica Neue',
  fullName: 'Helvetica Neue Light',
  postscriptName: 'HelveticaNeue-Light',
  category: 'sans-serif',
  ascent: 967,
  descent: -213,
  lineGap: 29,
  unitsPerEm: 1000,
  xWidthAvg: 433,
  subsets: {
    latin: {
      xWidthAvg: 433
    },
    thai: {
      xWidthAvg: 364
    }
  }
};
